import styled from 'styled-components/native';
import theme from '../../../global/styles/theme';

interface LoginButtonProps {
  backgroundColor: string;
  marginTop?: string;
}

export const Container = styled.View`
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  width: 100%;
  height: 100%;
`;

export const ContainerArea = styled.View<{appTheme: 'light' | 'dark'}>`
  flex: 1;
  width: 100%;
  background-color: ${({appTheme}) =>
    theme.colors(appTheme).backgroundColor};
`;

export const Image = styled.Image`
  height: 100px;
  margin-bottom: 20px;
`;

export const Column = styled.View`
  align-items: center;
  width: 90%;
`;

export const Body = styled.View`
  align-items: center;
  width: 100%;
`;

export const Footer = styled.View`
  flex-direction: row;
  margin-bottom: 10px;
  width: 90%;
`;

export const LoginButton = styled.TouchableOpacity<LoginButtonProps>`
  background-color: ${({backgroundColor}) => backgroundColor};
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  height: 50px;
  margin-top: ${({marginTop}) => marginTop || '0px'};
  width: 100%;
`;

export const LoginIcon = styled.Image`
  width: 28px;
  height: 28px;
  margin-right: 12px;
`;

export const ButtonBiometrics = styled.TouchableOpacity`
  align-items: center;
  justify-content: center;
  padding-left: 20px;
  padding-right: 20px;
  margin-bottom: 80px;
`;

export const ImgBiometrics = styled.Image`
  height: 40px;
  width: 40px;
`;
